import { createFileRoute } from '@tanstack/react-router';

import { AccountingPage } from '@/features/admin/AccountingPage';
import { requireRouteAccess } from '@/lib/routeGuards';

export const Route = createFileRoute('/_authed/admin/accounting')({
  beforeLoad: () => requireRouteAccess('/admin/accounting'),
  component: AccountingPage,
});
